"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getById = getById;
async function getById(productRepo, id) {
    return await productRepo.getById(id);
}
